<!-- START: apps/profile -->
<div class="row page-home">
    <div class="col-xl-8">
        <section class="card cat__apps__profile__card gradient-overlay"
                 style="min-height:250px; width:100%;">
            <div class="card-body text-center">
                <h3 class="white shadowed hero-label">{{ eventService.selectedEvent?.label }}</h3>
                <p class="text-white shadowed mt-3">
                    <span class="mr-2 event-date">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
                            <title></title>
                            <g id="icomoon-ignore"></g>
                            <path fill="#fff" d="M592 64h-80v-16c0-8.836-7.163-16-16-16s-16 7.164-16 16v16h-320v-16c0-8.836-7.164-16-16-16s-16 7.164-16 16v16h-80c-26.467 0-48 21.533-48 48v448c0 26.468 21.533 48 48 48h544c26.468 0 48-21.532 48-48v-448c0-26.467-21.532-48-48-48zM48 96h80v48c0 8.836 7.164 16 16 16s16-7.164 16-16v-48h320v48c0 8.836 7.163 16 16 16s16-7.164 16-16v-48h80c8.822 0 16 7.178 16 16v80h-576v-80c0-8.822 7.178-16 16-16zM592 576h-544c-8.822 0-16-7.178-16-16v-336h576v336c0 8.822-7.178 16-16 16z"></path>
                        </svg>

                        {{ eventService.selectedEvent?.date | date:'MMMM dd, yyyy'}}
                    </span>
                    <span class="mr-2 event-date">
                        <i class="fa fa-clock" aria-hidden="true"></i>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
                            <title></title>
                            <g id="icomoon-ignore"></g>
                            <path fill="#fff" d="M518.961 121.040c-57.418-57.418-133.76-89.040-214.961-89.040s-157.542 31.622-214.96 89.040c-57.418 57.418-89.040 133.759-89.040 214.96s31.622 157.543 89.040 214.961 133.759 89.039 214.96 89.039 157.543-31.621 214.961-89.039 89.039-133.76 89.039-214.961-31.621-157.542-89.039-214.96zM304 608c-149.981 0-272-122.019-272-272s122.019-272 272-272 272 122.019 272 272-122.019 272-272 272z"></path>
                            <path fill="#fff" d="M484.134 232c-4.419-7.653-14.205-10.272-21.856-5.856l-157.45 90.903-122.714-85.926c-7.239-5.069-17.216-3.309-22.284 3.929s-3.309 17.215 3.929 22.284l131.064 91.772c0.032 0.022 0.066 0.041 0.099 0.063 0.268 0.185 0.541 0.359 0.819 0.527 0.074 0.045 0.148 0.092 0.223 0.135 0.279 0.162 0.563 0.314 0.852 0.459 0.069 0.035 0.137 0.074 0.206 0.107 0.324 0.157 0.654 0.303 0.988 0.438 0.197 0.079 0.396 0.146 0.594 0.219 0.146 0.053 0.292 0.106 0.439 0.154 0.216 0.070 0.432 0.133 0.649 0.193 0.137 0.039 0.274 0.076 0.412 0.111 0.217 0.055 0.435 0.104 0.653 0.149 0.148 0.030 0.298 0.058 0.447 0.085 0.207 0.036 0.413 0.072 0.62 0.1 0.187 0.026 0.375 0.045 0.563 0.063 0.171 0.018 0.341 0.038 0.512 0.050 0.371 0.025 0.743 0.041 1.116 0.041 0.607 0 1.215-0.039 1.823-0.109 0.015-0.002 0.031-0.003 0.046-0.004 0.591-0.070 1.18-0.178 1.765-0.314 0.043-0.011 0.087-0.020 0.13-0.030 0.552-0.134 1.099-0.3 1.641-0.496 0.080-0.028 0.158-0.059 0.237-0.089 0.508-0.192 1.012-0.408 1.506-0.657 0.101-0.050 0.198-0.106 0.298-0.159 0.179-0.094 0.36-0.184 0.537-0.286l166.277-96c7.655-4.418 10.277-14.203 5.859-21.856z"></path>
                        </svg>

                        {{ eventService.selectedEvent?.time }}
                    </span>

                    <span class="mr-2 event-date">
                        {{eventService?.selectedEvent?.timezone}}
                    </span>

                </p>
            </div>
        </section>
        <!-- Not sure this makes sense here...
                <section class="card">
                    <div class="card-body">
                        <h5 class="mb-3 text-black">
                            <strong>Actions</strong>
                        </h5>
                        <div class="btn-group-vertical btn-group-justified">
                            <button type="button" class="btn">View Donations</button>
                            <button type="button" class="btn">Manage Contacts</button>
                            <button type="button" class="btn">View Statements</button>
                            <button type="button" class="btn">Change Event</button>
                        </div>
                    </div>
                </section>
                -->
        <section class="ui-fundraising-progress card" *ngIf="!permissionService.isApplyAdminProtectionRestrictionsEnabled()">
            <div class="card-body">
                <h4 class="mb-3 text-black d-inline-block">
                    <strong>Fundraising Goals</strong>
                </h4>
                <a class="text-primary ml-2 small ui-edit-team-goal button-svg text-uppercase"
                   (click)="openChangeGoalModal()"
                   *ngIf="!eventService?.selectedEvent?.isPastEvent">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
                        <title></title>
                        <g id="icomoon-ignore"></g>
                        <path fill="#cc0000" d="M611.313 28.686c-17.981-17.98-41.886-27.882-67.313-27.882-25.428 0-49.333 9.902-67.313 27.882l-408 408c-1.653 1.653-2.924 3.648-3.723 5.846l-64 176c-2.125 5.842-0.673 12.386 3.723 16.781 3.053 3.055 7.144 4.687 11.315 4.687 1.833 0 3.682-0.314 5.465-0.963l176-64c2.197-0.8 4.193-2.070 5.846-3.724l408-408c17.98-17.98 27.883-41.886 27.883-67.314s-9.902-49.333-27.883-67.313zM183.196 546.177l-140.443 51.069 51.070-140.442 354.177-354.177 89.373 89.373-354.177 354.177zM588.687 140.686l-28.687 28.687-89.373-89.373 28.687-28.687c11.936-11.936 27.806-18.509 44.686-18.509s32.75 6.574 44.687 18.51c11.936 11.936 18.51 27.806 18.51 44.686s-6.575 32.75-18.51 44.686z"></path>
                    </svg>
                    Edit
                </a>
                <div class="mb-3">
                    <div class="mb-1 ui-personal-goal">
                        <span class="text-black">Personal Goal:</span>
                        <span class="pull-right">
                            <span *ngIf="eventService?.selectedEvent?.donations?.individual?.goal > 0">
                                {{(eventService?.selectedEvent?.donations?.individual?.percentComplete).toFixed(0)}}%
                            </span>
                        </span>
                    </div>
                    <div class="progress" style="height: 7px;">
                        <div class="progress-bar bg-success" role="progressbar"
                             [attr.aria-valuenow]="eventService?.selectedEvent?.donations?.individual?.percentComplete"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="eventService?.selectedEvent?.donations?.individual?.percentComplete"></div>
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                        <div class="d-inline-block small">
                            RAISED
                            <span class="d-block amount font-number text-black">
                                ${{eventService?.selectedEvent?.donations?.individual?.totalRaised | number:'1.2-2'}}
                            </span>
                        </div>
                        <div class="d-inline-block small goal">
                            GOAL
                            <span *ngIf="eventService?.selectedEvent?.donations?.individual?.goal !== 0">
                                <span class="d-block amount font-number text-black">
                                ${{eventService?.selectedEvent?.donations?.individual?.goal | number}}
                            </span>
                            </span>
                            <span class="d-block amount font-number text-black" *ngIf="eventService?.selectedEvent?.donations?.individual?.goal === 0">-</span>
                        </div>
                    </div>
                    <span class="small text-muted"
                          *ngIf="eventService?.selectedEvent?.cssClass === 'program-tnt' && eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraisingMinimum">
                        Fundraising Minimum ${{eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser?.fundraisingMinimum}}
                    </span>
                </div>
                <div *ngIf="showTeamGoal" class="mb-3">
                    <div class="mb-1 ui-team-goal">
                        <span class="text-black" *ngIf="eventService?.selectedEvent?.cssClass === 'program-s2'">Class Goal:</span>
                        <span class="text-black" *ngIf="eventService?.selectedEvent?.cssClass !== 'program-s2'">Team Goal:</span>
                        <span class="pull-right" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingGoal !== 0">
                            {{(eventService?.selectedEvent?.donations?.team?.percentComplete).toFixed(0)}}%
                        </span>
                    </div>
                    <div class="progress" style="height: 7px;">
                        <div class="progress-bar bg-primary" role="progressbar"
                             [attr.aria-valuenow]="eventService?.selectedEvent?.donations?.team?.percentComplete"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="eventService?.selectedEvent?.donations?.team?.percentComplete"></div>
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                        <div class="d-inline-block small">
                            RAISED
                            <span class="d-block amount font-number text-black">
                                ${{eventService?.selectedEvent?.donations?.team?.totalRaised | number: '1.2-2'}}
                            </span>
                        </div>
                        <div class="d-inline-block small goal">
                            GOAL
                            <span *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingGoal !== 0">
                                <span class="d-block amount font-number text-black">
                                ${{eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingGoal | number}}
                                </span>
                            </span>
                            <span class="d-block amount font-number text-black" *ngIf="eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingGoal === 0">-</span>
                        </div>
                    </div>
                    <span class="small"
                          *ngIf="eventService?.selectedEvent?.cssClass === 'program-tnt' && eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingMinimum">
                        Team Fundraising Minimum ${{eventService?.selectedEvent?.gql?.Participant[0]?.team?.fundraiser?.fundraisingMinimum}}
                    </span>
                </div>
                <div class="row d-sm-none d-md-none d-lg-none d-xl-none mt-4">
                    <div class="col-12">
                        <div class="btn-group btn-group-justified mr-2 mb-2">
                            <div class="btn-group">
                                <button [routerLink]="['/donations']" type="button" class="btn btn-primary">View
                                    Donations
                                </button>
                            </div>
                            <div class="btn-group" *ngIf="!eventService?.selectedEvent?.isPastEvent && eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser.canAcceptDonations">
                                <button type="button" class="btn btn-primary" (click)="donationService.acceptIndividualDonation('Home Page')">Accept Donation</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="ui-fundraising-progress card" *ngIf="permissionService.isApplyAdminProtectionRestrictionsEnabled()">
            <admin-password></admin-password>
        </section>
        <section class="card">
            <div class="card-body pb-5">
                <h5 class="mb-3 text-black">
                    <strong>Welcome to Your Participant Center</strong>
                </h5>
                <div class="row">
                    <div class="col-12">
                        <p *ngIf="!uiStateService.campaignTexts[eventService?.selectedEvent?.cssClass]">
                            The Leukemia & Lymphoma Society's Light The Night Walk funds treatments that are saving the
                            lives of patients today. LLS is making cures happen by providing patient support services,
                            advocating for lifesaving treatments and pioneering the most promising cancer research anywhere.
                            And it's all happening now. Not someday, but today. Each year friends, families and coworkers
                            form teams to raise money in support of our mission.
                        </p>
                        <div *ngIf="uiStateService.campaignTexts[eventService?.selectedEvent?.cssClass]"
                            [innerHtml]="uiStateService.campaignTexts[eventService?.selectedEvent?.cssClass]">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div class="col-xl-4">
        <section class="card mt-0 recent-donations">
            <facebook-fundraiser *ngIf="hybridToolsService.canLinkToFacebook()"></facebook-fundraiser>
            <countdown-timer></countdown-timer>
            <div class="card-body" [ngClass]="{'pb-0': eventService?.selectedEvent?.donations?.donationList.length === 0}">
                <div class="quick-post">
                    <h4 class="text-black pb-0">
                        <strong>Check Donation Details
                            <i class="fa fa-question-circle"
                               ngbTooltip="For quicker processing, please include one of the following IDs on each check submitted."></i>
                        </strong>
                        <small class="d-block">
                            Personal ID: P{{eventService.selectedEvent && eventService?.selectedEvent?.gql?.Participant[0]?.participantId}}
                        </small>
                        <small class="d-block" *ngIf="eventService.selectedEvent && eventService?.selectedEvent?.gql?.Participant[0]?.team">
                            Team ID: T{{eventService.selectedEvent && eventService?.selectedEvent?.gql?.Participant[0]?.team?.teamId}}
                        </small>
                    </h4>
                    <hr />
                </div>
                <div class="quick-post" *ngIf="!eventService?.selectedEvent?.isPastEvent">
					<h4 class="text-black pb-0">
						<strong>Post to My Page</strong>
					</h4>
					<input type="text"
						   name="firstName"
						   class="form-control"
						   placeholder="Enter the title of your post..."
						   [(ngModel)]="postTitle"
						   id="home-PostToPage"
						   (focus)="onInputFocus()"
						   (blur)="onInputBlur()">
					<textarea class="form-control adjustable-textarea mt-4" placeholder="Post Content"
							  [(ngModel)]="textValue"
							  (focus)="onTextareFocus()"
							  (blur)="onTextareaBlur()"
							  *ngIf="isPostContentShown()">
					</textarea>
					<div class="mt-3 post" *ngIf="isPostButtonShown()">
						<button class="btn btn-primary btn-sm" (click)="post()">Post</button>
					</div>
					<hr *ngIf="!permissionService.isApplyAdminProtectionRestrictionsEnabled()" />
				</div>
                <div class="recent-donations-block" *ngIf="!permissionService.isApplyAdminProtectionRestrictionsEnabled()">
                    <h4 class="text-black mb-0 pb-0">
                        <strong>Recent Donations</strong>
                    </h4>
                    <hr *ngIf="eventService?.selectedEvent?.donations?.donationList.length !== 0"/>
                    <div class="no-activity pb-3 pt-3" *ngIf="eventService?.selectedEvent?.donations?.donationList.length === 0">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 640 640">
                            <title></title>
                            <g id="icomoon-ignore">
                            </g>
                            <path fill="#f4f4f4" d="M592 160h-96.044c10.067-13.38 16.044-30.004 16.044-48 0-44.112-35.888-80-80-80-44.488 0-81.793 35.238-100.070 56.242-11.067 12.719-20.596 26.335-27.929 39.505-7.333-13.169-16.863-26.786-27.93-39.505-18.278-21.004-55.582-56.242-100.071-56.242-44.112 0-80 35.888-80 80 0 17.996 5.977 34.62 16.043 48h-96.043c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h16v304c0 26.468 21.533 48 48 48h448c26.468 0 48-21.532 48-48v-304h16c8.837 0 16-7.164 16-16v-96c0-8.836-7.163-16-16-16zM356.070 109.248c25.022-28.756 52.698-45.248 75.93-45.248 26.468 0 48 21.533 48 48s-21.532 48-48 48h-108.091c5.534-14.138 16.724-33.011 32.161-50.752zM352 608h-96v-416h96v416zM128 112c0-26.467 21.533-48 48-48 23.233 0 50.908 16.492 75.93 45.248 15.437 17.741 26.627 36.614 32.161 50.752h-108.091c-26.467 0-48-21.533-48-48zM32 192h192v64h-192v-64zM64 592v-304h160v320h-144c-8.822 0-16-7.178-16-16zM544 592c0 8.822-7.178 16-16 16h-144v-320h160v304zM576 256h-192v-64h192v64z"></path>
                        </svg>
                        <span class="d-block">No Donations for this event yet</span>
                    </div>
                    <div class="cat__apps__profile__wall mt-3" *ngIf="eventService?.selectedEvent?.donations?.donationList.length !== 0">
                        <div class="cat__apps__profile__wall__item clearfix" *ngFor="let event of activity">
                            <div class="cat__apps__profile__wall__content" *ngIf="event.type === 'donation'">
                                <div class="mb-3 d-flex justify-content-between">
                                    <div>
                                        <strong class="text-black">{{event.obj.fullName}}</strong>
                                        <small class="text-muted d-block">{{event.obj.donationDate | date:'MMMM dd, yyyy h:mm'}}</small>
                                    </div>
                                    <span class="recent-amount font-number text-black">${{event.obj.amount.toFixed(2)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="load-more-container" *ngIf="activityCounter < eventService?.selectedEvent?.donations?.donationList.length">
                            <button class="btn btn-block load-more"
                                    (click)="loadMoreDonations()">Load More
                            </button>
                        </div>
                    </div>
                    <hr *ngIf="eventService?.selectedEvent?.donations?.donationList.length === 0"/>
                    <button *ngIf="!eventService?.selectedEvent?.isPastEvent && eventService?.selectedEvent?.gql?.Participant[0]?.fundraiser.canAcceptDonations" class="btn btn-primary width-200 d-block mt-3" (click)="donationService.acceptIndividualDonation('Home Page')">
                        Accept Donation
                    </button>
                </div>
            </div>
        </section>
    </div>
</div>
<!-- END: apps/profile -->
